import { buildInstanceWanda } from '@/api/instances'

const instanceWanda = buildInstanceWanda()

const addNewComment = async (store, { data, personId, healthEventId }) => {
  try {
    await instanceWanda.post(
      `person_health_events/${personId}/${healthEventId}/comment`,
      {
        json: data
      }
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthEvents/comments/addNewComment' },
      { root: true }
    )

    return {
      error: true
    }
  }
}

const getComments = async (store, { personId, healthEventId }) => {
  try {
    return await instanceWanda.get(
      `person_health_events/${personId}/${healthEventId}/comments`
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'healthEvents/comments/getComments' },
      { root: true }
    )
  }
}

export default {
  addNewComment,
  getComments
}
